import { render, staticRenderFns } from "./warn_def.vue?vue&type=template&id=27718290&"
import script from "./warn_def.vue?vue&type=script&lang=js&"
export * from "./warn_def.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports